export const isNull = (value: string | number | Date | boolean | any | undefined) : boolean => {
    if ( value === undefined) return true
    if ( value === null) return true
    if ( !value ) return true
    return false;
}